import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { Play, Pause, ShoppingCart, Disc3 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : "/api";

const CDN1 = "https://customer-assets.emergentagent.com/job_3a6acb3e-074e-41f3-a0be-676978ae6151/artifacts";
const CDN0 = "https://customer-assets.emergentagent.com/job_ed6a0deb-be55-415b-8702-764f1299165b/artifacts";

const NEW = "https://customer-assets.emergentagent.com/job_3a6acb3e-074e-41f3-a0be-676978ae6151/artifacts";

const ALBUMS = [
  {
    key: "mirrors", title: "Mirrors", artist: "VINCE SINNOTT",
    cover: `${NEW}/nghiht67_MIRRORS_1024x1024.jpg`,
    tracks: [
      { id: "m1", title: "13th St", url: `${CDN1}/ehvrkk6h_6A%20-%20113%20-%2013th%20St.mp3` },
      { id: "m2", title: "96 MIRRORS", url: `${CDN1}/xd54fjdg_8A%20-%20120%20-%2096%20MIRRORS.mp3` },
      { id: "m3", title: "WENOTDONE", url: `${CDN1}/umcbdu9h_12A%20-%20120%20-%20WENOTDONE.mp3` },
      { id: "m4", title: "$hango 1", url: `${CDN1}/y2ywa1ob_9B%20-%2096%20-%20%24hango%201.mp3` },
      { id: "m5", title: "Musical Chairs 2026", url: `${CDN1}/nuv46s0x_Musical%20Chairs%202026.wav` },
      { id: "m6", title: "Spun The Block", url: `${CDN1}/ctvnadiy_Spun%20The%20Block.mp3` },
      { id: "m7", title: "Here 2day Gone 2morrow", url: `${CDN1}/ki6mg2o7_7B%20-%20126%20-%20Here%202day%20Gone%202morrow%201.0%20Master.mp3` },
    ],
  },
  {
    key: "codes", title: "CODES", artist: "VINCE SINNOTT",
    cover: `${NEW}/v6sfsrhe_CODES%20Album%20Cover.jpg`,
    tracks: [],
    itunes_album_id: "1812232122",
    preview: true,
  },
  {
    key: "in-memory-of", title: "In Memory Of", artist: "VINCE SINNOTT",
    cover: `${NEW}/0naz4521_%22In%20Memory%20Of%22%20Cover%20Art.jpeg`,
    tracks: [],
  },
  {
    key: "13", title: "13", artist: "VINCE SINNOTT",
    cover: `${NEW}/zqmer3ut_%2213%22%20Cover%20Art.jpg`,
    tracks: [
      { id: "t1", title: "13Elieve", url: `${CDN1}/e3bmyvap_13Elieve.m4a` },
      { id: "t2", title: "Homme Sweet Home", url: `${CDN1}/asrjwzoa_Homme%20Sweet%20Home.m4a` },
      { id: "t3", title: "Leo's House", url: `${CDN1}/hf6ijlup_Leo%27s%20House.m4a` },
      { id: "t4", title: "Lost", url: `${CDN1}/ivufjxie_Lost.m4a` },
      { id: "t5", title: "The 2nd Coming", url: `${CDN1}/vf45z7fx_The%202nd%20Coming%20%28feat.%20Boogie%20Dash%29.m4a` },
    ],
  },
  {
    key: "presence", title: "Presence", artist: "VINCE SINNOTT",
    cover: `${NEW}/a24t5yb5_Presence%20Album%20Cover.jpeg`,
    tracks: [
      { id: "p1", title: "Still N.Y.C", url: `${CDN1}/u7nbzcl5_9A%20-%2090%20-%20Still%20N.Y.C.m4a` },
      { id: "p2", title: "Etheric Template", url: `${CDN1}/hgz4viax_Etheric%20Template.m4a` },
      { id: "p3", title: "Le Vision", url: `${CDN1}/cwusivq6_Le%20Vision.m4a` },
      { id: "p4", title: "1990 6", url: `${CDN1}/7w67b8gl_1990%206.mp3` },
      { id: "p5", title: "Feel Like Summer", url: `${CDN1}/czql7f6q_Feel%20Like%20Summer%20%28Vmix%29.mp3` },
    ],
  },
  {
    key: "lucid-dreams", title: "Lucid Dreams", artist: "VINCE SINNOTT",
    cover: `${CDN1}/37hk2mpj_Lucid%20Dreams%20Album%20Cover.jpg`,
    tracks: [
      { id: "ld1", title: "Lucid Dreams", url: `${CDN1}/k0bx6olb_Lucid%20Dreams.m4a` },
      { id: "ld2", title: "New Waves", url: `${CDN1}/oyfkic7r_New%20Waves.m4a` },
      { id: "ld3", title: "Play Rough", url: `${CDN1}/08436du3_Play%20Rough%28feat%20Boogie%20Dash%29.m4a` },
      { id: "ld4", title: "Worry Free", url: `${CDN1}/qqgseck7_Worry%20Free.m4a` },
    ],
  },
];

function formatSec(s) {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, "0")}`;
}

export default function SoundLab() {
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const [expandedAlbum, setExpandedAlbum] = useState(null);
  const [playingId, setPlayingId] = useState(null);
  const [isPaused, setIsPaused] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [albums, setAlbums] = useState(ALBUMS);
  const progressRef = useRef(null);

  const stopAudio = () => {
    if (audioRef.current) { audioRef.current.pause(); audioRef.current.currentTime = 0; }
    if (progressRef.current) clearInterval(progressRef.current);
    setPlayingId(null); setIsPaused(false); setProgress(0); setDuration(0);
  };

  useEffect(() => () => { stopAudio(); }, []);

  // Hydrate iTunes 30s previews for any album flagged with itunes_album_id
  useEffect(() => {
    let cancelled = false;
    (async () => {
      for (const a of ALBUMS) {
        if (!a.itunes_album_id || a.tracks.length > 0) continue;
        try {
          const res = await fetch(`${API}/itunes/album/${a.itunes_album_id}`);
          if (!res.ok) continue;
          const data = await res.json();
          if (cancelled) return;
          const mapped = (data.tracks || [])
            .filter(t => t.preview_url)
            .map(t => ({ id: `${a.key}-${t.track_number}`, title: t.title, url: t.preview_url, preview: true, track_number: t.track_number }));
          setAlbums(prev => prev.map(al => al.key === a.key ? { ...al, tracks: mapped } : al));
        } catch {}
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const playTrack = (track) => {
    if (!track?.url) return;
    if (playingId === track.id && !isPaused) { audioRef.current?.pause(); setIsPaused(true); if (progressRef.current) clearInterval(progressRef.current); return; }
    if (playingId === track.id && isPaused) { audioRef.current?.play(); setIsPaused(false); startProgress(); return; }
    stopAudio();
    const audio = new Audio(track.url);
    audio.volume = 0.7;
    audioRef.current = audio;
    audio.play();
    setPlayingId(track.id); setIsPaused(false);
    audio.addEventListener("loadedmetadata", () => setDuration(audio.duration));
    audio.addEventListener("ended", () => { setPlayingId(null); setIsPaused(false); setProgress(0); if (progressRef.current) clearInterval(progressRef.current); });
    startProgress();
  };

  const startProgress = () => {
    if (progressRef.current) clearInterval(progressRef.current);
    progressRef.current = setInterval(() => {
      if (audioRef.current) { setProgress(audioRef.current.currentTime); setDuration(audioRef.current.duration || 0); }
    }, 250);
  };

  const totalTracks = albums.reduce((s, a) => s + a.tracks.length, 0);

  return (
    <div className="border border-[#FF0000]/15 bg-black/80 p-4 space-y-3" data-testid="sound-lab">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[10px] tracking-widest uppercase text-[#FF0000]/60 font-mono flex items-center gap-2">
            <Disc3 className="w-3.5 h-3.5" /> SOUND LAB
          </div>
          <div className="text-[8px] font-mono text-[#FF0000]/30 mt-0.5">{albums.length} albums &middot; {totalTracks} tracks</div>
        </div>
        <button onClick={() => navigate("/sound")}
          className="text-[9px] font-mono tracking-wider text-[#FF0000]/40 hover:text-[#FF0000] border border-[#FF0000]/15 hover:border-[#FF0000]/40 px-2.5 py-1 transition-all"
          data-testid="soundlab-open-store">
          OPEN STORE
        </button>
      </div>

      {/* Album Grid */}
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2" data-testid="soundlab-album-grid">
        {albums.map(album => (
          <button key={album.key}
            onClick={() => setExpandedAlbum(expandedAlbum === album.key ? null : album.key)}
            className={`group relative overflow-hidden border transition-all ${
              expandedAlbum === album.key
                ? "border-[#FF0000]/50 shadow-[0_0_12px_rgba(255,0,0,0.15)]"
                : "border-[#FF0000]/10 hover:border-[#FF0000]/30"
            }`}
            data-testid={`soundlab-album-${album.key}`}>
            <div className="aspect-square relative">
              <img src={album.cover} alt={album.title} className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-1.5">
                <div className="text-[9px] font-mono font-bold text-[#FF0000] truncate leading-tight">{album.title}</div>
                <div className="text-[7px] font-mono text-[#FF0000]/40">{album.tracks.length || "—"} tracks</div>
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Expanded Track List */}
      {expandedAlbum && (() => {
        const album = albums.find(a => a.key === expandedAlbum);
        if (!album) return null;
        return (
          <div className="border border-[#FF0000]/15 bg-[#050000]/80 p-3 space-y-2" data-testid={`soundlab-tracklist-${album.key}`}>
            <div className="flex items-center gap-3">
              <img src={album.cover} alt={album.title} className="w-10 h-10 object-cover border border-[#FF0000]/20" />
              <div className="min-w-0 flex-1">
                <div className="text-sm font-mono font-bold text-[#FF0000]">{album.title}</div>
                <div className="text-[9px] font-mono text-[#FF0000]/40">{album.artist} &middot; {album.tracks.length} tracks</div>
              </div>
              <button onClick={() => navigate("/sound")}
                className="flex items-center gap-1 px-2 py-1 text-[8px] font-mono border border-[#FF0000]/30 text-[#FF0000]/60 hover:text-[#FF0000] hover:border-[#FF0000]/50 transition-all"
                data-testid={`soundlab-buy-${album.key}`}>
                <ShoppingCart className="w-3 h-3" /> BUY $13
              </button>
            </div>
            {album.tracks.length === 0 ? (
              <div className="text-[9px] font-mono text-[#FF0000]/25 py-3 text-center">Tracks coming soon</div>
            ) : (
              <div className="space-y-0.5">
                {album.tracks.map((track, i) => {
                  const isThis = playingId === track.id;
                  const isActive = isThis && !isPaused;
                  const pct = isThis && duration > 0 ? (progress / duration) * 100 : 0;
                  return (
                    <div key={track.id}
                      className={`flex items-center gap-2 px-2 py-1.5 transition-colors ${isThis ? "bg-[#FF0000]/5" : "hover:bg-[#FF0000]/3"}`}
                      data-testid={`soundlab-track-${track.id}`}>
                      <button onClick={() => playTrack(track)}
                        className="w-6 h-6 flex items-center justify-center shrink-0"
                        data-testid={`soundlab-play-${track.id}`}>
                        {isActive ? <Pause className="w-3.5 h-3.5 text-[#FF0000]" /> : <Play className="w-3.5 h-3.5 text-[#FF0000]/60" />}
                      </button>
                      <span className="text-[9px] font-mono text-[#FF0000]/30 w-4 shrink-0">{i + 1}</span>
                      <span className={`text-[10px] font-mono truncate flex-1 ${isThis ? "text-[#FF0000]" : "text-[#FF0000]/70"}`}>{track.title}</span>
                      {track.preview && (
                        <span className="text-[7px] font-mono tracking-widest text-[#FF0000]/40 border border-[#FF0000]/20 px-1 py-0.5 shrink-0">30s</span>
                      )}
                      {isThis && (
                        <span className="text-[8px] font-mono text-[#FF0000]/40 shrink-0">{formatSec(progress)}/{formatSec(duration)}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            {playingId && albums.find(a => a.key === expandedAlbum)?.tracks.some(t => t.id === playingId) && (
              <div className="w-full h-0.5 bg-[#FF0000]/10">
                <div className="h-full bg-[#FF0000] transition-none" style={{ width: `${duration > 0 ? (progress / duration) * 100 : 0}%` }} />
              </div>
            )}
          </div>
        );
      })()}
    </div>
  );
}
